import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { useFormTcfVendor, useI18n } from "../../../../contexts";
import { FormHeadline } from "../../headline";
import { FORM_TCF_VENDOR_FIELD_PURPOSES_COLUMN_NAME_WIDTH, FormLayoutTcfVendor } from "..";
import { Empty, Table } from "antd";
const { Column } = Table;
const FormTcfVendorFieldDataDeclaration = ()=>{
    const { __ } = useI18n();
    const { vendor, declarations: { dataCategories } } = useFormTcfVendor();
    const useDataDeclarations = useMemo(()=>Object.values(dataCategories).filter((dataCategory)=>vendor.dataDeclaration.indexOf(dataCategory.id) > -1), [
        vendor,
        dataCategories
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FormHeadline, {
                offset: FormLayoutTcfVendor.labelCol.span,
                description: __("Data categories are specified by the vendor and are immutable. They describe the characteristics of which personal data is processed."),
                children: __("Data categories")
            }),
            /*#__PURE__*/ _jsxs(Table, {
                locale: {
                    emptyText: /*#__PURE__*/ _jsx(Empty, {
                        description: __("This vendor has not listed any data categories.")
                    })
                },
                dataSource: useDataDeclarations,
                rowKey: "id",
                size: "small",
                bordered: true,
                pagination: false,
                children: [
                    /*#__PURE__*/ _jsx(Column, {
                        width: FORM_TCF_VENDOR_FIELD_PURPOSES_COLUMN_NAME_WIDTH,
                        title: __("Name"),
                        dataIndex: "name"
                    }, "name"),
                    /*#__PURE__*/ _jsx(Column, {
                        title: __("Description"),
                        dataIndex: "description"
                    }, "description")
                ]
            })
        ]
    });
};
export { FormTcfVendorFieldDataDeclaration };
